import { Box, Button, Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useCallback, useEffect, useRef, useState } from "react";
import DetailedEvaluation from "../Components/ProposalSummary/DetailedEvaluation";
import FinalRecommendation from "../Components/ProposalSummary/FinalRecommendation";
import GradingSummary from "../Components/ProposalSummary/GradingSummary";
import ProposalDetails from "../Components/ProposalSummary/ProposalDetails";
import service from "../Helpers/gifservices";
import { useSelector } from "react-redux";
import { canEditSelector, refereeSelector } from "../../../store/refereeSlice";
import { useReactToPrint } from "react-to-print";
import { useHistory } from "react-router";
import { MAIN_PAGE_URL, refereeStatus } from "../Constants";
import { useLoading } from "../../../providers/loadingProvider";
import { useConfirm } from "../../../Contexts/ConfirmContext/ConfirmService";
import { useAlert } from "../../../Contexts/AlertContext/AlertService";

// const proposalRefereeId = "8AB2B0C6-2350-EB11-A812-000D3ADC3CB0";

const useStyles = makeStyles((theme) => ({
  printButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: "#FFFFFF",
    backgroundColor: theme.palette.gif.blue.color,
    // float: "right",
    width: 120,
    marginTop: 15,
    marginLeft: 6,
    borderRadius: 8,
  },
  closeButton: {
    // float: "right",
    marginLeft: 15,
    width: 120,
    marginTop: 15,
    borderRadius: 8,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  box: {
    // height: 1500,
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
  },
  sendButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.green.hover,
    },
    color: "#FFFFFF",
    backgroundColor: theme.palette.gif.green.dark,
    float: "right",
    marginTop: 15,
    borderRadius: 8,
  },
}));

export default function ProposalSummary() {
  const classes = useStyles();
  const componentRef = useRef();
  const history = useHistory();
  const loading = useLoading();
  const confirm = useConfirm();
  const alert = useAlert();
  const referee = useSelector(refereeSelector);
  const canEdit = useSelector(canEditSelector);
  const [proposalRefereeId, setProposalRefereeId] = useState(null);
  const [proposalReferee, setProposalReferee] = useState();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const SendEvaluation = async () => {
    const res = await confirm({
      title: "Confirm Send Evaluation",
      description: "Are you sure you want to send the evaluation? after evaluation send you wont be able to edit the evaluation",
    });
    if (!res) return;
    const loadingId = loading.addLoading("Sending Evaluation");
    const newpr = {
      ...proposalReferee,
      statusCode: refereeStatus.sentEvaluation,
    };
    setProposalReferee(newpr);
    await service.UpdateRefereeRecommendation({ proposalReferee: newpr });
    loading.removeLoading(loadingId);
    await alert({
      title: "Evaluation Sent Successfully!",
      description: `Thank you for your evaluation.
      Click OK to return to Dashboard`,
    });
    history.push(MAIN_PAGE_URL);
  };

  useEffect(() => {
    setProposalRefereeId(referee?.id);
  }, [referee]);

  const GetProposalReferee = useCallback(async () => {
    if (!proposalRefereeId) return;
    const loadingId = loading.addLoading("Loading Proposal");

    var proposalReferee = await service.GetProposalRefereeById({
      proposalRefereeId,
    });
    setProposalReferee(proposalReferee);
    loading.removeLoading(loadingId);
  }, [proposalRefereeId, loading]);

  useEffect(() => {
    GetProposalReferee();
  }, [proposalRefereeId, GetProposalReferee]);

  return (
    <Box marginLeft={10}>
      <Box height={600} className={classes.box}>
        <Grid container spacing={1} ref={componentRef}>
          <Grid item xs={4}>
            <ProposalDetails proposalReferee={proposalReferee} />
          </Grid>
          <Grid item xs={8}>
            <DetailedEvaluation proposalReferee={proposalReferee} />
          </Grid>
          <Grid item xs={12}>
            <GradingSummary proposalReferee={proposalReferee} />
          </Grid>
          <Grid item xs={12}>
            <FinalRecommendation proposalReferee={proposalReferee} />
          </Grid>
        </Grid>
      </Box>
      <Button
        variant="contained"
        className={classes.sendButton}
        disableElevation
        onClick={SendEvaluation}
        disabled={!canEdit}
      >
        Send Evaluation
      </Button>
      <Button
        disableElevation
        variant="contained"
        className={classes.closeButton}
        onClick={() => history.push(MAIN_PAGE_URL)}
        // onClick={() => acceptProposal(proposalReferee.itemID)}
      >
        Close
      </Button>
      <Button
        disableElevation
        variant="contained"
        className={classes.printButton}
        onClick={handlePrint}
        // onClick={() => acceptProposal(proposalReferee.itemID)}
      >
        Print
      </Button>
    </Box>
  );
}
